<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <woot-modal-header :header-title="$t('PIPELINES.EDIT_PIPELINE')" />
    <div class="remainder-table">
      <div class="remainder-modal">
        <div class="remainder-input date-time">
          <div class="date-time-input">
            <label>
              {{ $t('PIPELINES.EDIT_NAME') }}
              <span class="text-red-500">*</span>
              <woot-input
                class="status-name mt-2"
                :class="{ error: $v.name.$error }"
                :placeholder="'Pipeline Name'"
                v-model.trim="name"
                :error="getLabelTitleErrorPipeline"
                @input="$v.name.$touch"
              />
            </label>
            <label>
              {{ $t('PIPELINES.EDIT_DESCRIPTION') }}
              <div class="my-editor mt-2">
                <div class="editor-ui rounded-md" :class="{ error: $v.description.$error }">
                  <editor
                    v-model="description"
                    :placeholder="'Add Remark...'"
                     @input="$v.description.$touch"
                  />
                </div>
                <span v-if="$v.description.$error" class="text-red-500">
                     {{ getDescriptionError }}
                  </span>
              </div>
            </label>
            <label>
              <label>
              <div class="color-picker-wrapper mt-2">
                <p class="mb-2">{{ $t('PIPELINES.SELECT_COLOR') }}</p>
                <div  class="flex flex-wrap gap-1">
                  <div
                    v-for="(fixedColor, index) in colors"
                    :key="index"
                    @click="setColor(fixedColor)"
                    :style="{
                      backgroundColor: fixedColor,
                      width: '40px',
                      height: '40px',
                      cursor: 'pointer',
                      border: fixedColor === color ? '3px solid black' : '1px solid #ccc',
                      borderRadius: '50%',
                    }"
                  ></div>
                </div>
              </div>
            </label>
            </label>
            <!-- <label>
              <label for="draggable">Draggable:</label>
              <input type="checkbox" v-model="draggable" id="draggable" />
            </label> -->
            <!-- <div>
              <woot-submit-button :button-text="'Edit'" :disabled="uiFlags.isUpdating" @click="editStatus" />
            </div> -->
            <div class="flex justify-end items-center pb-6 pt-2 gap-2 w-full">
              <woot-submit-button
                :button-text="'Update'"
                class="button-color"
                :disabled="
                  !isSubmitEnabled ||
                  uiFlags.isUpdating ||
                  !formHasChanged"
                :loading="uiFlags.isUpdating"
                @click="editStatus"
              />
              <woot-button
                class="button clear cancel-btn"
                @click.prevent="onClose"
              >
                {{ $t('LABEL_MGMT.FORM.CANCEL') }}
              </woot-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import validations from './helpers/validations';
import pipelineMixin from './helpers/pipelineMixin.js';
import Editor from 'dashboard/components/widgets/WootWriter/Editor.vue';
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    getModaldata: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  components: {
    Editor,
  },
  mixins: [alertMixin, pipelineMixin],
  data() {
    return {
      name: this.getModaldata.name || '',
      description: this.getModaldata.description || '',
      color: this.getModaldata.color || '',
      id: this.getModaldata.id || null,
      draggable: this.getModaldata.dragable || false,
      originalName: this.getModaldata.name || '',
      originalDescription: this.getModaldata.description || '',
      originalColor: this.getModaldata.color || '',
      // color: '#34922D', // Default selected color
      // colors: [
      //   '#34922D',
      //   '#FFCC00',
      //   '#2D6FF5',
      //   '#B700AB',
      //   '#D62222',
      //   '#D9488C',
      //   '#FF7700',
      //   '#40518A',
      //   '#4300B7',
      //   '#009EB7',
      // ], // Fixed list of colors
      color: '#EFF3FF',
      colors: [
        '#EFF3FF',
        '#FFF2CC',
        '#DAF8D3',
        '#FDE8E9',
        '#ffa3a3',
        '#ffc3df',
        '#ffc18c',
        '#a7bbff',
        '#ceb2ff',
        '#a7f3ff',
      ],
    };
  },
  validations,
  computed: {
    ...mapGetters({
      uiFlags: 'pipelines/getUIFlags',
    }),
    formHasChanged() {
      return (
        this.name !== this.originalName ||
        this.description !== this.originalDescription ||
        this.color !== this.originalColor
      );
    },
  },
  mounted() {
    console.log('Get Modal Data', this.getModaldata);
  },
  watch: {
    getModaldata(newVal) {
      // Log whenever the prop changes
      console.log('getModaldata updated:', newVal, newVal.color);
      this.id = newVal.id;
      this.name = newVal.name;
      this.description = newVal.description ?? '';
      this.color = newVal.color;
      this.draggable = newVal.dragable;
      // Update original values on modal data change
      this.originalName = newVal.name;
      this.originalDescription = newVal.description;
      this.originalColor = newVal.color;
    },
  },
  methods: {
    async editStatus() {
      // try {
      const boardId = this.$route.params.board_id;
      const updateObj = {
        name: this.name,
        description: this.description,
        color: this.color,
        draggable: this.draggable,
        board_id: boardId
      };
      const id = this.id;
      console.log('My Id is', id, updateObj);
      //   let response = await axios.put(
      //     `api/v1/accounts/${this.$route.params.accountId}/statuses/${id}`,
      //     dataToSend
      //   );
      //   console.log('Response', response);
      // } catch (error) {
      //   console.error('Error sending data to server:', error);
      // } finally {
      //   this.onClose();
      //   this.showAlert(response.data.message);
      // }
      const response = await this.$store.dispatch('pipelines/updateStatusId', {
        id,
        updateObj,
      });
      console.log('Response', response);
      this.onClose();
      this.getStatus();
      this.showAlert(response.data.message, { success: response.data.success });

      bus.$emit('dropdown-data', true);
      bus.$emit('reset-date-dropdown');
      if(boardId!=undefined)
      {
        console.log("My Board Id",boardId);
        bus.$emit('dropdown-boardId',boardId)
      }
    },
    async getStatus() {
      const boardId = this.$route.params.board_id;
      this.$store.dispatch('pipelines/getStatus',{ board_id: boardId });
      const data = {
        key: 'state_id',
        value: '', // The state filter
        key1: 'name',
        value1: '', // The name filter
        key2: 'start_date',
        value2: '', // The start date filter
        key3: 'end_date',
        value3: '', // The end date filter
        key4: 'board_id',
        value4: boardId
      };
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    onClose() {
      this.$emit('close');
    },
    setColor(selectedColor) {
      this.color = selectedColor;
    },
  },
};
</script>

<style lang="scss" scoped>
.remainder-table {
  margin: 10px 35px;
}

.remainder-modal {
  display: flex;
}

.remainder-input {
  width: 100%;
}
.remainder-text {
  width: 20%;
  font-size: 14px;
  font-weight: 500;
}
.remainder-text-select {
  padding: 5% 0px;
}
.input-textarea textarea {
  resize: none;
}
.date-time {
  display: flex;
  justify-content: space-between;
}
.date,
.time {
  margin: 0px 2%;
}
.remainder-time {
  display: flex;
  justify-content: inherit;
  width: 35%;
}
.date-time-input {
  width: 100%;
}
.footer {
  @apply mt-6 flex justify-end;
}
.remainder-time select {
  width: 66%;
}
.remainder-footer {
  flex-direction: inherit;
}
.labels-dropdown {
  display: flex;
  width: 45%;
  justify-content: space-evenly;
}
.automation-dropdown {
  display: flex;
  width: 45%;
  justify-content: space-evenly;
}
.label-automation {
  padding-top: 10px;
  justify-content: space-between;
}
.labels-text {
  width: 30%;
}
.label-input {
  width: 50%;
}
.automation-text {
  width: 55%;
}
.automation-input {
  width: 50%;
}
.overlay {
  position: fixed;
  margin: auto;
  left: 50vw;
  width: 250px;
}
.success-popup {
  background-color: #44ce4b;
  color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  position: relative;
}
.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
  font-size: 20px;
}
.date-time-picker-modal {
  width: 90%;
  padding-top: 2%;
}
.cancel-btn {
  background-color: #fff;
  color: #40518a;
}
.cancel-btn:hover {
  background-color: #f9f9f9;
  color: #40518a;
}
.button-color {
  background-color: #40518a;
}
.editor-ui {
  border: 2px solid lightgrey;
  height: 200px;
  padding-left: 10px;
}
</style>
  